import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
import "./../myReactSelect.css";
import swal from "@sweetalert/with-react";
// import Swal from "sweetalert2";
import { baseurl } from "../../../../baseurl";
import axios from "axios";
import { GetIp } from "./../Get_ip";
import { checkPermission } from "../../../../Helper";
import ResponseLoader from "./../ResponseLoader";
export default function ItemForm(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  var delArr = [];
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [tempDeletedArr, setTempDeletedArr] = useState([]);
  const [disableAllFeilds, setDisableAllFeilds] = useState(false);

  const [data, setData] = useState({
    customer: "",
    firstName: "",
    lastName: "",
    address: "",
    email: "",
    phoneNo: "",
    city: "",
    country: "",
    formValuesAdditional: [
      {
        lineNum: 1,
        contact: "",
        cellNo: "",
        email: "",
        defaultYN: null,
      },
    ],
    showModalAddNew: true,
    activity: props?.propData?.location?.rowData?.referencePk,
  });

  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    let uomId = data.uom?.id;
    if (uomId) props.toggle(uomId);
    else props.toggle();
  };

  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    if (
      name === "defaultRateShow" &&
      value === "1" &&
      Number(data.defaultRate) <= 0
    ) {
      swal({
        title: "Default rate should be more than 0",
        text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
        icon: "warning",
      });
      setData({
        ...data,
        defaultRate: 1,
        [name]: value,
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };
  const addFormFieldsItemAdditional = () => {
    let lineNumber = data.formValuesAdditional.length + 1;
    setData({
      ...data,
      formValuesAdditional: [
        ...data.formValuesAdditional,
        {
          lineNum: lineNumber,
        },
      ],
      show: false,
    });
  };

  const removeFormFieldsItemAdditional = (element, i) => {
    let formValuesAdditional = data.formValuesAdditional;
    if (formValuesAdditional.length > 1) {
      formValuesAdditional.splice(i, 1);

      if (element.detId) {
        setTempDeletedArr([...delArr, { id: element.detId }]);
      }
      setData({
        ...data,
        formValuesAdditional,
      });
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
    }
  };

  const inputEventDetFeilds = (e, index) => {
    const value = e.target.value;
    const name = e.target.name;

    if (props.EditData > -1) {
      let formValuesAdditional = data.formValuesAdditional;

      formValuesAdditional[index][name] = value;
      formValuesAdditional[index]["update"] = 1;

      setData({ ...data, formValuesAdditional });
    } else {
      let formValuesAdditional = data.formValuesAdditional;

      formValuesAdditional[index][name] = value;

      setData({ ...data, formValuesAdditional });
    }
  };
  const handleRadioChange = (e, index) => {
    if (props.EditData > -1) {
      setData((prevData) => {
        const updatedFormValues = prevData.formValuesAdditional.map(
          (item, idx) => ({
            ...item,
            defaultYN: idx === index ? 1 : 0,
            update: 1,
          })
        );
        return { ...prevData, formValuesAdditional: updatedFormValues };
      });
    } else {
      setData((prevData) => {
        const updatedFormValues = prevData.formValuesAdditional.map(
          (item, idx) => ({
            ...item,
            defaultYN: idx === index ? 1 : 0,
          })
        );
        return { ...prevData, formValuesAdditional: updatedFormValues };
      });
    }
  };

  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
      if (openModalCheck) {
        toggleAddNew();
        return;
      }
    };
    if (props.EditData > -1) {
      setLoadingResponce(true);
      if (props.updateCheck === 0) {
        funCall(0);
        setDisableAllFeilds(true);
      } else {
        funCall(2);
      }
      let resData;
      let tableId = props.EditData;
      setLoadingResponce(true);
      axios
        .post(
          `${baseurl}/CRM/getCRMCustById`,
          { id: tableId, companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((res) => {
          resData = res.data.data;
          let customer,
            firstName,
            lastName,
            address,
            city,
            country,
            email,
            phoneNo;
          const updatedFormAdditionalAttrib = [...data.formValuesAdditional]; // Create a copy of the existing formValuesVariant

          for (let index = 0; index < resData.length; index++) {
            customer = resData[index]["COMPANY_NAME"];
            firstName = resData[index]["FIRST_NAME"];
            lastName = resData[index]["LAST_NAME"];
            address = resData[index]["ADDRESS1"];
            email = resData[index]["CUSTOMER_EMAIL"];
            phoneNo = resData[index]["PhoneNo"];
            city = resData[index]["CITY"];
            country = resData[index]["cdm_country"];

            updatedFormAdditionalAttrib[index] = {
              detId: resData[index]["contact_id"],
              contact: resData[index]["name"],
              cellNo: resData[index]["phone"],
              email: resData[index]["email"],
              defaultYN: resData[index]["default_yn"],
            };
          }
          setData({
            ...data,
            customer,
            firstName,
            lastName,
            address,
            email,
            phoneNo,
            city,
            country,
            formValuesAdditional: updatedFormAdditionalAttrib,
          });
          setLoadingResponce(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      funCall(1);
    }
  }, []);

  const asyncRollCheck = async (value) => {
    let pathname = "/AddCrmCustomerForm";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    setLoadingResponce(true);
    var companyId = localStorage.getItem("companyId");
    let { userIp, userCountry } = await getUserIp();
    let Id = props.EditData;
    if (Id > -1) {
      const formValuesAdditionalForUpdate = [...data.formValuesAdditional];
      let tempArrForNew = [];
      let tempArrForUpdate = [];
      formValuesAdditionalForUpdate.forEach((item) => {
        if (item.detId && item.update) {
          tempArrForUpdate.push(item);
        } else if (!item.detId) {
          tempArrForNew.push(item);
        }
      });
      setLoadingResponce(true);

      axios
        .post(
          `${baseurl}/CRM/updateCrmCustomer`,
          {
            companyId,
            Id,
            customer: data.customer,
            firstName: data.firstName,
            lastName: data.lastName,
            address: data.address,
            email: data.email,
            phoneNo: data.phoneNo,
            city: data.city,
            country: data.country,
            formValuesForAdd: tempArrForNew,
            formValuesForUpdate: tempArrForUpdate,
            formValuesForDelete: tempDeletedArr,
            username: username,
            userIp,
            userCountry,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          setLoadingResponce(false);
          if (response.data.duplicate === true) {
            swal({
              title: "Duplicate Code is not Allowed",
              text: "Duplicate Entry",
              icon: "error",
            });
          } else {
            swal({
              title: "Saved Successfully!",
              text: "Customer Updated",
              icon: "success",
            }).then((value) => {
              toggleAddNew();
            });
          }
        })
        .catch(function (error) {
          console.log("erooor", error);
          setLoadingResponce(false);

          swal({
            title: "Error",
            text: "Something went wrong, try to refresh the page and try again.",
            icon: "error",
          });
        });
    } else {
      setLoadingResponce(true);

      axios
        .post(
          `${baseurl}/CRM/addCrmCustomer`,
          {
            Id,
            companyId,
            customer: data.customer,
            firstName: data.firstName,
            lastName: data.lastName,
            address: data.address,
            email: data.email,
            phoneNo: data.phoneNo,
            city: data.city,
            country: data.country,
            formValuesAdditional: data.formValuesAdditional,
            username: username,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          setLoadingResponce(false);
          console.log("Response data:", response.data.dataSubmitted); // Log the response data
          let dataSubmitted = response.data.dataSubmitted;
          console.log("dataSubmitted", dataSubmitted);
          if (response.data.duplicate === true) {
            swal({
              title: "Duplicate Code is not Allowed",
              text: "Duplicate Entry",
              icon: "error",
            });
          } else {
            swal({
              title: "Success!",
              text: "Customer Added!",
              icon: "success",
            }).then((value) => {
              toggleAddNew();
              setLoadingResponce(true);
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          setLoadingResponce(false);

          swal({
            title: "Error",
            text: "Something went wrong, try to refresh the page and try again.",
            icon: "error",
          });
        });
    }
    setLoadingResponce(false);
  };

  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div>
          <Modal
            show={data.showModalAddNew}
            size="xl"
            onHide={toggleAddNew}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={toggleAddNew}
              className=" Creative-Invoice-header-styling"
            >
              <Row>
                <strong>
                  <h4 className="ml-1">
                    {" "}
                    {props.EditData > -1 && props.updateCheck === 1
                      ? "Update"
                      : props.EditData > -2 && props.updateCheck === 0
                      ? "View"
                      : "Add"}{" "}
                    Customer{" "}
                  </h4>
                </strong>
              </Row>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="row">
                    <div className="col-md-12">
                      <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                        <div className="row">
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Customer:
                            </Label>
                            <Input
                              value={data.customer}
                              onChange={inputEvent}
                              required
                              name="customer"
                              id="customer"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              First Name:
                            </Label>
                            <Input
                              value={data.firstName}
                              onChange={inputEvent}
                              required
                              name="firstName"
                              id="firstName"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Last Name:
                            </Label>
                            <Input
                              value={data.lastName}
                              onChange={inputEvent}
                              required
                              name="lastName"
                              id="lastName"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Address:
                            </Label>
                            <Input
                              value={data.address}
                              onChange={inputEvent}
                              required
                              name="address"
                              id="address"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>City:</Label>
                            <Input
                              value={data.city}
                              onChange={inputEvent}
                              required
                              name="city"
                              id="city"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Country:
                            </Label>
                            <Input
                              value={data.country}
                              onChange={inputEvent}
                              required
                              name="country"
                              id="country"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>Email:</Label>
                            <Input
                              value={data.email}
                              onChange={inputEvent}
                              required
                              name="email"
                              id="email"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                          <div
                            className="col-md-4"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Phone Number:
                            </Label>
                            <Input
                              value={data.phoneNo}
                              onChange={inputEvent}
                              required
                              name="phoneNo"
                              id="phoneNo"
                              isClearable
                              disabled={disableAllFeilds}
                            />
                          </div>
                        </div>
                        <hr
                          style={{
                            border: "1px solid ",
                            marginBottom: "3vh",
                            marginTop: "3vh",
                            borderColor: "E4E5E6",
                          }}
                        />
                        <div className="div my-0">
                          <div className="InvoiceLine-styling ">
                            <div class="row">
                              <div className="col-md-2">
                                <Label>
                                  Contact Name:
                                  <span className="text-danger">*</span>
                                </Label>
                              </div>
                              <div className="col-md-2">
                                <Label>
                                  Cell No:
                                  <span className="text-danger">*</span>
                                </Label>
                              </div>
                              <div className="col-md-3">
                                <Label>
                                  Email:
                                  <span className="text-danger">*</span>
                                </Label>
                              </div>
                              <div className="col-md-1">
                                <Label>
                                  Default:
                                  <span className="text-danger">*</span>
                                </Label>
                              </div>
                            </div>

                            {data.formValuesAdditional.map((element, index) => (
                              <>
                                <div class="row">
                                  <div className="col-md-2 my-1">
                                    <Input
                                      value={element.contact || ""}
                                      onChange={(e) =>
                                        inputEventDetFeilds(e, index)
                                      }
                                      required
                                      name="contact"
                                      id="contact"
                                      isClearable
                                      disabled={disableAllFeilds}
                                    />
                                  </div>
                                  <div className="col-md-2 my-1">
                                    <Input
                                      value={element.cellNo || ""}
                                      onChange={(e) =>
                                        inputEventDetFeilds(e, index)
                                      }
                                      required
                                      name="cellNo"
                                      id="cellNo"
                                      isClearable
                                      disabled={disableAllFeilds}
                                    />
                                  </div>
                                  <div className="col-md-3 my-1">
                                    <Input
                                      type="email"
                                      value={element.email || ""}
                                      onChange={(e) =>
                                        inputEventDetFeilds(e, index)
                                      }
                                      // onBlur={(e) => handleEmail(e, index)}
                                      required
                                      name="email"
                                      id="email"
                                      placeholder="example@gmail.com"
                                      isClearable
                                      disabled={disableAllFeilds}
                                    />
                                  </div>
                                  <div className="col-md-1 my-1 d-flex justify-content-center">
                                    <input
                                      type="radio"
                                      value={element.defaultYN}
                                      checked={element.defaultYN === 1}
                                      onChange={(e) =>
                                        handleRadioChange(e, index)
                                      }
                                      required
                                      name="defaultYN"
                                      id="defaultYN"
                                      isClearable
                                      disabled={disableAllFeilds}
                                    />
                                  </div>

                                  <div
                                    className="col-md-2 pt-2 d-flex justify-content-center"
                                    // style={{ textAllign: "right" }}
                                  >
                                    <div>
                                      <Button
                                        className="btn btn-info text-white mx-2"
                                        type="button"
                                        disabled={disableAllFeilds}
                                        size="sm"
                                        onClick={() =>
                                          addFormFieldsItemAdditional()
                                        }
                                      >
                                        <i className="fa fa-plus "></i>
                                      </Button>

                                      <Button
                                        type="button"
                                        size="sm"
                                        className="btn btn-danger"
                                        disabled={disableAllFeilds}
                                        onClick={() =>
                                          removeFormFieldsItemAdditional(
                                            element,
                                            index
                                          )
                                        }
                                      >
                                        <i className="fa fa-trash "></i>
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                        <hr
                          style={{
                            border: "1px solid ",
                            marginBottom: "3vh",
                            marginTop: "1vh",
                            borderColor: "E4E5E6",
                          }}
                        />
                        <FormGroup>
                          {!disableAllFeilds ? (
                            <Button
                              className="mr-1 invoiceSubmitButton "
                              disabled={loadingResponce}
                            >
                              {props.EditData > -1 ? "Update" : "Save"} Changes
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            onClick={() => toggleAddNew()}
                            className="mr-1"
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </FormGroup>
                      </Form>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
